import React from 'react';
import { FlexiflowComponent } from '@flexiflow-ui-kit/system';
import { Hint } from '@flexiflow-ui-kit/hint';
import styled from 'styled-components';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var CheckboxVariant;

(function (CheckboxVariant) {
  CheckboxVariant["Checkbox"] = "checkbox";
  CheckboxVariant["Toggle"] = "toggle";
})(CheckboxVariant || (CheckboxVariant = {}));

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
var MainContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  width: auto;\n  display: flex;\n\n  .hint__container {\n    width: auto;\n  }\n"])), function (p) {
  return p.theme.predefinedCss.borderBoxChildren;
});
var CheckboxLabel = styled.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  cursor: ", ";\n"])), function (p) {
  return p.theme.palette.black;
}, function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'not-allowed' : 'pointer';
});
var InputContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 24px;\n  min-width: 24px;\n  height: 24px;\n  min-height: 24px;\n  cursor: ", ";\n\n  input {\n    position: absolute;\n    opacity: 0;\n  }\n\n  span {\n    position: absolute;\n    width: 24px;\n    height: 24px;\n    border: 1px solid ", ";\n    border-radius: 2px;\n    background-repeat: no-repeat;\n    background-position: center center;\n  }\n\n  input:hover:enabled + span {\n    border: 1px solid ", ";\n  }\n\n  input:checked + span {\n    background-color: ", ";\n    border-color: ", ";\n    background-image: url(\"data:image/svg+xml,%3Csvg width='12' height='9' viewBox='0 0 12 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 3.14286L4.91304 7L11 1' stroke='white' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E\");\n  }\n\n  input:checked:hover:enabled + span {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  input:not(:checked):disabled + span {\n    border: 1px solid ", ";\n  }\n\n  input:checked:disabled + span {\n    background-color: ", ";\n    border: 1px solid ", ";\n  }\n"])), function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (p) {
  return p.theme.palette.gray['400'];
}, function (p) {
  return p.theme.palette.gray['500'];
}, function (p) {
  return p.theme.palette.blue['500'];
}, function (p) {
  return p.theme.palette.blue['500'];
}, function (p) {
  return p.theme.palette.blue['800'];
}, function (p) {
  return p.theme.palette.blue['800'];
}, function (p) {
  return p.theme.palette.gray['300'];
}, function (p) {
  return p.theme.palette.blue['300'];
}, function (p) {
  return p.theme.palette.blue['300'];
});
var CheckboxLabelText = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 20px;\n  margin-left: 8px;\n  color: ", ";\n  color: ", ";\n"])), function (p) {
  return p.theme.palette.black;
}, function (p) {
  return p.disabled ? p.theme.palette.gray['500'] : p.theme.palette.black;
});
var ToggleLabelText = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 20px;\n  color: ", ";\n"])), function (p) {
  return p.disabled ? p.theme.palette.gray['500'] : p.theme.palette.black;
});
var ToggleSwitchLabel = styled.label(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  height: 24px;\n  position: relative;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  cursor: ", ";\n"])), function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? 'not-allowed' : 'pointer';
});
var ToggleInput = styled.input(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n\n  &:checked + span:before {\n    transform: translateX(14px);\n  }\n  &:checked + span {\n    background-color: ", ";\n  }\n  &:checked:hover + span {\n    background-color: ", ";\n  }\n  &:checked:disabled + span {\n    background-color: ", ";\n  }\n  &:not(:checked) + span {\n    background: ", ";\n  }\n  &:not(:checked):hover + span {\n    background-color: ", ";\n  }\n  &:not(:checked):disabled + span {\n    background-color: ", ";\n  }\n"])), function (p) {
  return p.theme.palette.blue['500'];
}, function (p) {
  return p.theme.palette.blue['800'];
}, function (p) {
  return p.theme.palette.blue['300'];
}, function (p) {
  return p.theme.palette.gray['500'];
}, function (p) {
  return p.theme.palette.gray['600'];
}, function (p) {
  return p.theme.palette.gray['300'];
});
var Slider = styled.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  cursor: ", ";\n  background-color: #d3d6dc;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n  transition: 0.4s;\n  border-radius: 34px;\n  display: block;\n  width: 40px;\n  height: 24px;\n  position: relative;\n  &:before {\n    height: 20px;\n    width: 20px;\n    background-color: #fff;\n    bottom: 4px;\n    top: 2px;\n    content: '';\n    left: 3px;\n    position: absolute;\n    transition: 0.4s;\n    border-radius: 50%;\n  }\n"])), function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? 'not-allowed' : 'pointer';
});
var ToggleContainer = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", ";\n  .hint__container {\n    width: auto;\n    cursor: ", ";\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n"])), function (p) {
  return p.theme.predefinedCss.borderBoxChildren;
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? 'not-allowed' : 'pointer';
});

var _excluded = ["className", "disabled", "label", "hint", "hintKeepPlace", "hintCanDisabled", "hasError", "variant"];
function Checkbox(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      label = _ref.label,
      hint = _ref.hint,
      hintKeepPlace = _ref.hintKeepPlace,
      hintCanDisabled = _ref.hintCanDisabled,
      hasError = _ref.hasError,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? CheckboxVariant.Checkbox : _ref$variant,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, variant === CheckboxVariant.Checkbox ? /*#__PURE__*/React.createElement(MainContainer, {
    className: className
  }, /*#__PURE__*/React.createElement(Hint, {
    hint: hint,
    hasError: hasError,
    hintKeepPlace: hintKeepPlace,
    disabled: disabled,
    hintCanDisabled: hintCanDisabled
  }, /*#__PURE__*/React.createElement(CheckboxLabel, {
    disabled: disabled,
    className: "checkbox__label"
  }, /*#__PURE__*/React.createElement(InputContainer, {
    disabled: disabled
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    disabled: disabled
  }, otherProps)), /*#__PURE__*/React.createElement("span", null)), label && /*#__PURE__*/React.createElement(CheckboxLabelText, {
    disabled: disabled
  }, label)))) : /*#__PURE__*/React.createElement(ToggleContainer, {
    className: className,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(Hint, {
    hint: hint,
    hasError: hasError,
    hintKeepPlace: hintKeepPlace,
    disabled: disabled,
    hintCanDisabled: hintCanDisabled
  }, /*#__PURE__*/React.createElement(ToggleSwitchLabel, {
    disabled: disabled
  }, label && /*#__PURE__*/React.createElement(ToggleLabelText, {
    disabled: disabled
  }, label), /*#__PURE__*/React.createElement(ToggleInput, _extends({
    type: "checkbox",
    disabled: disabled
  }, otherProps)), /*#__PURE__*/React.createElement(Slider, {
    disabled: disabled
  })))));
}

export { Checkbox, CheckboxVariant };
